// extracted by mini-css-extract-plugin
export var closeButton = "_26-0";